var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { applyMiddleware, compose, createStore } from 'redux';
import { PersistGate } from 'redux-persist/integration/react';
import { router } from '@/route';
import { getApiClient } from './api';
import { propShape } from './helpers/custom-prop-types';
import BowserState from './helpers/window/BowserState';
import reducer from './reducers';
import './scss/main.scss';
import { getReduxLogger, getSagaMiddleware } from './sideEffect';
import { persistReducer, persistStore } from './sideEffect/persist';
import HubSpot from './vendor/HubSpot';
class AppIndex extends Component {
    constructor(props) {
        super(props);
        const { store } = props;
        this.state = {
            persistor: persistStore(store, () => {
                this.setState({ rehydrated: true });
            }),
            rehydrated: false,
        };
        // Append class for IE
        const { browser } = BowserState.bowser;
        const browserName = browser.name;
        const body = document.querySelector('body');
        const setName = ((checkName) => {
            if (checkName === 'Internet Explorer') {
                return 'ie';
            }
            return '';
        })(browserName);
        body.className = `${body.className} ${setName}`;
    }
    render() {
        const { persistor, rehydrated } = this.state;
        const { store } = this.props;
        if (rehydrated) {
            return (_jsx(Provider, Object.assign({ store: store }, { children: _jsx(PersistGate, Object.assign({ persistor: persistor }, { children: _jsx(RouterProvider, { router: router }) })) })));
        }
        return null;
    }
}
AppIndex.propTypes = {
    store: propShape().isRequired,
};
const init = () => __awaiter(void 0, void 0, void 0, function* () {
    // 実行用のAPIクラスを設定
    const apiClient = yield getApiClient();
    // Middleware の準備
    const middlewares = [];
    // Sagaの作成
    const { sagaMiddleware, sagaRun } = getSagaMiddleware(apiClient);
    middlewares.push(sagaMiddleware);
    const { compose: wrapCompose, logger } = getReduxLogger();
    if (logger) {
        middlewares.push(logger);
    }
    // reducerの用意とミドルウェアの登録
    const store = createStore(persistReducer(reducer), (wrapCompose || compose)(applyMiddleware(...middlewares)));
    sagaRun();
    // Hubspotチャットボットの初期値設定
    HubSpot.setHsConversationsSettings();
    ReactDOM.render(_jsx(AppIndex, { store: store }), document.getElementById('app'));
    return 'start app';
});
init().then();
